var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "gv-header" }, [
    _c(
      "div",
      { staticClass: "gv-content-bar" },
      [
        _c(
          "router-link",
          {
            staticClass: "gv-icon d-flex align-items-center",
            attrs: { to: { name: "Dashboard" } },
          },
          [_c("img", { attrs: { src: _vm.logo, height: "35" } })]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gv-menu-bar" },
          [
            _vm.user
              ? _c(
                  "router-link",
                  {
                    staticClass: "gv-link rounded-pill",
                    staticStyle: { width: "130px" },
                    attrs: { to: { name: "Profile" } },
                  },
                  [
                    _c("i", { staticClass: "bi bi-people" }),
                    _vm._v(" "),
                    _c("small", { staticClass: "ml-1" }, [
                      _vm._v(_vm._s(_vm.user.name)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "gv-link",
                on: {
                  click: function ($event) {
                    return _vm.LOGOUT()
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-box-arrow-right" })]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "gv-banner",
                on: {
                  click: function ($event) {
                    return _vm.SHOW()
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.collapse ? "fas fa-times" : "fas fa-bars",
                }),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }